import classNames from "@calcom/ui/classNames";

export function Logo({
	small,
	icon,
	inline = true,
	className,
	src = "/api/logo",
}: {
	small?: boolean;
	icon?: boolean;
	inline?: boolean;
	className?: string;
	src?: string;
}) {
	return (
		<h3 className={classNames("logo", inline && "inline", className)}>
			<strong>
				{icon ? (
					<img
						className="mx-auto w-9 rounded-lg bg-white p-0.5"
						alt="Reach Response"
						title="Reach Response"
						src={`${src}?type=icon`}
					/>
				) : (
					<img
						className={classNames(
							small ? "h-4 w-auto" : "h-5 w-auto",
							"box-content rounded-md bg-white px-1 py-0.5",
						)}
						alt="Reach Response"
						title="Reach Response"
						src={src}
					/>
				)}
			</strong>
		</h3>
	);
}
